import { render, staticRenderFns } from "./TabReports.vue?vue&type=template&id=3e560736&scoped=true&"
import script from "./TabReports.vue?vue&type=script&lang=js&"
export * from "./TabReports.vue?vue&type=script&lang=js&"
import style0 from "./TabReports.vue?vue&type=style&index=0&id=3e560736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e560736",
  null
  
)

export default component.exports